import React from 'react'

export default()=>(
    <style js="true">{`

    img.headerLogo {
        margin-left: -5px;
        margin-top: -8px!important;
    }
    .termsandcondition-heading {
        font-weight: 700;
    }
    .TermsandCondition.margin-bottom-of-terms {
        padding-bottom: 60px;
    }
    .TermsandCondition {
        background-color: #eee;
        padding: 10px;
        margin-top: 39px;
    }
    .terms-and-conditions{
        font-size: 38px;
        margin: 15px;
        margin-top: 60px;
        background-color: #fff;
        padding: 60px;
        width: 1000px;
        margin-right: auto;
        margin-left: auto;
    }
    .termsandcondition-heading {
        margin-left: 30px;
    }
        .strong {  
            display: block;
            font-size: 26px;
            margin: 15px;
            line-height: 40px;
           
            
             }
            .ol {
                display: block;
                list-style-type: decimal;
                margin-block-start: 1em;
                margin-block-end: 1em;
                margin-inline-start: 0px;
                margin-inline-end: 0px;
                padding-inline-start: 40px!important;
                font-size: 25px;
                line-height: 45px;
               
            }

            .li {
                display: list-item;
                text-align: -webkit-match-parent;
                line-height: 40px;
                overflow-wrap: break-word;
                color: #333;
                font-size: 25px!important;
                
            }
           .ap {
            padding-inline-start: 40px!important;
            font-size: 25px;
            line-height: 45px;
           

           }

        ` }

    </style>
);